/**
 * تقييم الانضباط (0–1) كما في salary-info / الملف الشخصي:
 * خصم التأخيرات المجمدة في calattendancerecords + تقدير الغياب.
 */
export function computeDisciplineStarRatio(listRow, workDaysCount) {
  const count =
    Number(workDaysCount) > 0 ? Number(workDaysCount) : 30;
  const salary = Number(listRow?.salary) || 0;
  if (salary <= 0) return 0;
  const latePrice = Number(listRow?.lateTimePrice || 0);
  const attDays = Number(listRow?.attendanceDays || 0);
  const absentDays = count - attDays;
  const absentPrice = Math.round(absentDays * (salary / count));
  const totalDeduction = latePrice + absentPrice;
  const starRating = 1 - totalDeduction / salary;
  return starRating > 0 ? starRating : 0;
}

export function clampStarPercent(value) {
  const n = Number(value);
  if (!Number.isFinite(n)) return 0;
  return Math.max(0, Math.min(100, n));
}

/** قيمة Rate (0–5، نصف نجمة) كما في الملف الشخصي */
export function disciplineStarRatioToRateValue(ratio) {
  const starPercent = clampStarPercent(Math.round((Number(ratio) || 0) * 100));
  return Math.max(0, Math.min(5, Math.round((starPercent / 20) * 2) / 2));
}
